import AssetsIcon from '@mui/icons-material/CameraRoll'
import WebIcon from '@mui/icons-material/Web'
import {
  PAGES_AEM_DATA_TYPE_KEY,
  FILE_ASSETS_AEM_DATA_TYPE_KEY,
} from '../../adobe-experience-manager-inbound/components'
import { DataOption } from '../../components'

export const DataSelectionOptions = [
  {
    type: FILE_ASSETS_AEM_DATA_TYPE_KEY,
    label: 'Assets',
    icon: AssetsIcon,
  },
  {
    type: PAGES_AEM_DATA_TYPE_KEY,
    label: 'Pages',
    icon: WebIcon,
  },
] as const satisfies DataOption[]
